var _defs, _rect, _rect2, _rect3, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew277({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3.38,
    y: 2.5,
    width: 9.25,
    height: 4.17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 3.38,
    y: 2.65,
    width: 4.62,
    height: 1.93
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 8,
    y: 4.58,
    width: 4.62,
    height: 1.93
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 7.31,
    r: 0.53
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.76,13.5V9.71H5.85v.45H4.17v1.17H5.62v.45H4.17V13.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.38,13.5V9.71h.41v1.56H8.4V9.71h.41V13.5H8.4V11.72H6.79V13.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.51,13.5V9.71h1.37a1.47,1.47,0,0,1,.64.11.82.82,0,0,1,.34.35,1.33,1.33,0,0,1,.13.57,1,1,0,0,1-.88,1,1.05,1.05,0,0,1,.27.21,2.36,2.36,0,0,1,.32.48l.54,1h-.51l-.42-.79a5.22,5.22,0,0,0-.36-.62.69.69,0,0,0-.24-.22.85.85,0,0,0-.32,0H9.92V13.5Zm.41-2.12h.88a1,1,0,0,0,.44-.07.49.49,0,0,0,.24-.21.68.68,0,0,0,.09-.35.58.58,0,0,0-.17-.45.69.69,0,0,0-.5-.17h-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew277);
export default __webpack_public_path__ + "static/media/Symbolpack_New_277.61bc9d4c9dae011abb5558668f3c3d04.svg";
export { ForwardRef as ReactComponent };